import { ErrorHandler, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { BufferedErrorHandler } from './app/buffered-error-handler';

// Sentry подключается после старта приложения, поэтому ошибки этого окна нужно запомнить и отдать
// ему позже: иначе всё упавшее до его загрузки не дойдёт до мониторинга.
const MAX_EARLY_ERRORS = 20;
const earlyErrors: unknown[] = [];

function rememberEarlyError(event: ErrorEvent | PromiseRejectionEvent): void {
  if (earlyErrors.length >= MAX_EARLY_ERRORS) {
    return;
  }

  earlyErrors.push('reason' in event ? event.reason : event.error);
}

function stopRememberingEarlyErrors(): void {
  window.removeEventListener('error', rememberEarlyError);
  window.removeEventListener('unhandledrejection', rememberEarlyError);
}

if (!isDevMode()) {
  window.addEventListener('error', rememberEarlyError);
  window.addEventListener('unhandledrejection', rememberEarlyError);
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (isDevMode()) {
      return;
    }

    const errorHandler = appRef.injector.get(ErrorHandler);

    if (!(errorHandler instanceof BufferedErrorHandler)) {
      return;
    }

    void import('./app/sentry-lazy')
      .then(({ startSentry }) => {
        stopRememberingEarlyErrors();
        startSentry(errorHandler, appRef.injector.get(Router), earlyErrors);
      })
      .catch((error: unknown) => {
        // Чанк не догрузился: без приёмника ошибки остались бы в буфере молча, поэтому
        // подключаем консоль — видимость важнее тишины.
        stopRememberingEarlyErrors();
        errorHandler.connect((buffered) => {
          // eslint-disable-next-line no-console
          console.error(buffered);
        });
        earlyErrors.forEach((buffered) => {
          // eslint-disable-next-line no-console
          console.error(buffered);
        });
        // eslint-disable-next-line no-console
        console.error(error);
      });
  })
  .catch((err) =>
    // eslint-disable-next-line no-console
    console.error(err),
  );
